var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCopyOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.1001 1.85988V7.3202C3.1001 7.56157 3.19598 7.79304 3.36665 7.96371C3.53731 8.13438 3.76879 8.23026 4.01015 8.23026H7.65037C7.89173 8.23026 8.1232 8.13438 8.29387 7.96371C8.46454 7.79304 8.56042 7.56157 8.56042 7.3202V3.33508C8.5604 3.21384 8.53616 3.09383 8.48912 2.98209C8.44208 2.87035 8.37319 2.76914 8.28649 2.68439L6.77808 1.20919C6.60806 1.04295 6.37974 0.949859 6.14195 0.949829H4.01015C3.76879 0.949829 3.53731 1.04571 3.36665 1.21638C3.19598 1.38705 3.1001 1.61852 3.1001 1.85988V1.85988Z",
    stroke: "#88898A",
    strokeWidth: 0.910054,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.74059 8.23027V9.14032C6.74059 9.38168 6.64471 9.61316 6.47405 9.78383C6.30338 9.9545 6.0719 10.0504 5.83054 10.0504H2.19033C1.94897 10.0504 1.71749 9.9545 1.54682 9.78383C1.37615 9.61316 1.28027 9.38168 1.28027 9.14032V4.13503C1.28027 3.89367 1.37615 3.66219 1.54682 3.49152C1.71749 3.32086 1.94897 3.22498 2.19033 3.22498H3.10038",
    stroke: "#88898A",
    strokeWidth: 0.910054,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopyOutline);
export default __webpack_public_path__ + "static/media/icon-copy-outline.1c0c49d3c74b5176bb3ff3f0884dbcc3.svg";
export { ForwardRef as ReactComponent };